import React,{useState} from "react";

import { Modal, Button, Image } from "react-bootstrap";

import cx from "classnames";
import styles from "./Modal.module.scss";

export default function CustomModal(props) {
  const [show, setShow] = useState(props.show)
  return (
    <Modal show={show} onHide={()=>setShow(false)} contentClassName={cx(styles.modal)} size="xl" centered>
      <Modal.Header bsPrefix={styles.modalheader} >
        <span className={styles.header}>{props.title}</span>  
        <i onClick={()=>setShow(false)} className={cx("icon-close",styles.closeIcon)}/>
      </Modal.Header>
      {props.children}
    </Modal>
  );
}

export const SaveDialog = ({ onCancel, onConfirm, isSaving, error }) => {
  return (
    <Modal
      show={true}
      backdrop="static"
      centered
      onHide={onCancel}
      className={styles.saveModal}
      dialogClassName={styles.saveDialog}
      contentClassName={styles.dialogContent}
      backdropClassName={styles.saveBackdrop}
    >
      <Modal.Body className={styles.dialogBody}>
        <Button
          variant="info"
          onClick={onCancel}
          className={styles.closeButton}
          disabled={isSaving}
        >
          <i className={cx(styles.icon, "cleverstory-close")} />
        </Button>
        <div className={styles.message}>
          <div className={styles.left}>
            <h2 className={styles.title}>Wanna Switch Pages?</h2>

            <p>
              Are you sure you wanna switch page,
              you have unsaved changes?
            </p>

            <footer className={styles.actions}>
              <Button
                className={styles.action}
                variant="secondary"
                onClick={onCancel}
                disabled={isSaving}
              >
                Cancel
              </Button>

              <Button
                className={styles.action}
                variant="primary"
                onClick={onConfirm}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save & Switch"}
              </Button>
            </footer>
          </div>

          <Image
            src={"/images/acquireLock.png"}
            width={270}
            className={styles.publishImage}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};